import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import Colour from 'color';
import useLeaderboardStore from './state-hook';
import { MainText } from './styles';
import RoundedAvatar from '../../common/filters-components/contributors-components/rounded-avatar';

const Column = styled.div`
  flex-grow: 2;
  display: flex;
  flex-direction: column;

  & > .header {
    ${MainText};
    display: flex;
    flex-direction: column;
  }

  & > .row {
    display: flex;
    align-items: center;
  }
`;

const Text = styled.span`
  color: ${props => props.theme.bodyColor};
  white-space: nowrap;
  margin-left: 20px;
  font: ${props => props.theme.fontWeightHeavy} 16px/16px ${props => props.theme.fontFamilyBody};
  letter-spacing: 0.1px;
  min-width: 210px;
`;

const h = 33;
const w = 87;
const hPad = 8;
const PlainWrapper = styled.div`
  width: ${w}px;
  height: ${h}px;
`;

const CompanyWrapper = styled(PlainWrapper)`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0 ${hPad}px;
  border-radius: 2px;
  background-color: ${props => props.bgColor};
  box-shadow: 0px 0.7px 3.6px rgba(0, 0, 0, 0.08);

  & > img {
    object-fit: contain;
    max-height: ${h}px;
    max-width: ${w - hPad * 2}px;
  }
`;

const white = '#ffffff';

const Company = ({
  color, name, logo,
}) => {
  let c;
  try {
    c = Colour(color || white);
  } catch (err) {
    c = Colour(white);
  }

  if (!logo) {
    return <PlainWrapper />;
  }

  return (
    <CompanyWrapper bgColor={c}>
      <img src={logo} alt={name || 'logo'} />
    </CompanyWrapper>
  );
};

Company.propTypes = {
  color: PropTypes.string,
  name: PropTypes.string,
  logo: PropTypes.string,
};

Company.defaultProps = {
  color: null,
  name: null,
  logo: null,
};

const Contributor = ({
  name, profilePictureUrl, company,
}) => (
  <div className="row">
    <RoundedAvatar {...{ name, profilePictureUrl }} />
    <Text>{name}</Text>
    <Company {...(company || {})} />
  </div>
);

Contributor.propTypes = {
  name: PropTypes.string.isRequired,
  profilePictureUrl: PropTypes.string,
  company: PropTypes.shape({
    color: PropTypes.string,
    name: PropTypes.string,
    logo: PropTypes.string,
  }),
};

Contributor.defaultProps = {
  profilePictureUrl: null,
  company: null,
};

export default function Contributors() {
  const current = useLeaderboardStore(state => state.current);

  return (
    <Column>
      <div className="header">contributor</div>
      {current.map(d => <Contributor key={d.id} {...d} />)}
    </Column>
  );
}
